import axios from "axios";

export const listUpsells = (cursor, limit, success, failure) => {
    let url = "/api/v1/upsell/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const createUpsell = (upsell, success, failure) => {
    const url = "/api/v1/upsell/";

    axios.post(url, {
        name: upsell.name,
        description: upsell.description,
        landingPageUrl: upsell.landingPageUrl,
        price: upsell.price,
        order: upsell.order,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const saveUpsell = (upsellId, upsell, success, failure) => {
    const url = `/api/v1/upsell/${upsellId}/`;

    axios.put(url, {
        name: upsell.name,
        description: upsell.description,
        landingPageUrl: upsell.landingPageUrl,
        price: upsell.price,
        order: upsell.order,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};
